(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game-model/assets/javascripts/radio/rules-radio.js') >= 0) return;  svs.modules.push('/components/numbergames/game-model/assets/javascripts/radio/rules-radio.js');

'use strict';

svs.numbergames.game_model.rulesRadio = Radio.channel(svs.numbergames.game_model.rulesRadioChannel);
let rules;
svs.numbergames.game_model.rulesRadio.on('setRules', rulesObject => {
  rules = rulesObject;
});
svs.numbergames.game_model.rulesRadio.reply('rules', () => rules);

 })(window);